function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _await(value, then, direct) {
  if (direct) {
    return then ? then(value) : value;
  }
  if (!value || !value.then) {
    value = Promise.resolve(value);
  }
  return then ? value.then(then) : value;
}
function _async(f) {
  return function () {
    for (var args = [], i = 0; i < arguments.length; i++) {
      args[i] = arguments[i];
    }
    try {
      return Promise.resolve(f.apply(this, args));
    } catch (e) {
      return Promise.reject(e);
    }
  };
}
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _classPrivateFieldInitSpec(e, t, a) { _checkPrivateRedeclaration(e, t), t.set(e, a); }
function _checkPrivateRedeclaration(e, t) { if (t.has(e)) throw new TypeError("Cannot initialize the same private elements twice on an object"); }
function _classPrivateFieldGet(s, a) { return s.get(_assertClassBrand(s, a)); }
function _classPrivateFieldSet(s, a, r) { return s.set(_assertClassBrand(s, a), r), r; }
function _assertClassBrand(e, t, n) { if ("function" == typeof e ? e === t : e.has(t)) return arguments.length < 3 ? t : n; throw new TypeError("Private element is not present on this object"); }
import debug from 'debug';
import { flattenFnArray } from './utils';
import { IlcIntl } from 'ilc-sdk/app';
var _registryConf = /*#__PURE__*/new WeakMap();
var _bundleLoader = /*#__PURE__*/new WeakMap();
var _getAppSdkAdapter = /*#__PURE__*/new WeakMap();
var _debug = /*#__PURE__*/new WeakMap();
var _propsInjector = /*#__PURE__*/new WeakMap();
var ParcelApi = /*#__PURE__*/_createClass(function ParcelApi(registryConf, bundleLoader, getAppSdkAdapter) {
  var _this = this;
  _classCallCheck(this, ParcelApi);
  _classPrivateFieldInitSpec(this, _registryConf, void 0);
  _classPrivateFieldInitSpec(this, _bundleLoader, void 0);
  _classPrivateFieldInitSpec(this, _getAppSdkAdapter, void 0);
  _classPrivateFieldInitSpec(this, _debug, void 0);
  _defineProperty(this, "importParcelFromApp", _async(function (appName, parcelName) {
    var app = _classPrivateFieldGet(_registryConf, _this).apps[appName];
    if (!app) {
      throw new Error("Unable to find requested app \"".concat(appName, "\" in Registry"));
    }
    return _await(_classPrivateFieldGet(_bundleLoader, _this).loadAppWithCss(appName), function (appBundle) {
      if (!appBundle.parcels || !appBundle.parcels[parcelName]) {
        throw new Error("Looks like application \"".concat(appName, "\" doesn't export requested parcel: ").concat(parcelName));
      }
      var parcelCallbacks = appBundle.parcels[parcelName];
      var intlInstances = {};
      return _classPrivateFieldGet(_propsInjector, _this).call(_this, parcelCallbacks, function (props, lifecycleType) {
        var intlForUnmount;
        if (lifecycleType === 'unmount') {
          intlForUnmount = intlInstances[props.name];
          delete intlInstances[props.name]; // We delete reference on unmount to cleanup memory

          if (intlForUnmount) {
            intlForUnmount.unmount();
          }
        } else if (!intlInstances[props.name]) {
          var adapter = _classPrivateFieldGet(_getAppSdkAdapter, _this).call(_this, props.name);
          intlInstances[props.name] = new IlcIntl(props.name, adapter.intl);
        }
        var resultingProps = _objectSpread(_objectSpread({}, props), {}, {
          parcelSdk: {
            parcelId: props.name,
            registryProps: app.props,
            intl: intlInstances[props.name] || intlForUnmount
          }
        });
        _classPrivateFieldGet(_debug, _this).call(_this, "".concat(lifecycleType.toUpperCase(), " for parcel \"").concat(parcelName, "\" from app \"").concat(appName, "\" with: "), resultingProps);
        return resultingProps;
      });
    });
  }));
  _classPrivateFieldInitSpec(this, _propsInjector, function (callbacks, modifyPropsCb) {
    var resCallbacks = {};
    var _loop = function _loop(lifecycle) {
      if (!callbacks.hasOwnProperty(lifecycle)) {
        return 1; // continue
      }
      var callback = flattenFnArray(callbacks, lifecycle);
      resCallbacks[lifecycle] = function (props) {
        return callback(modifyPropsCb(props, lifecycle));
      };
    };
    for (var lifecycle in callbacks) {
      if (_loop(lifecycle)) continue;
    }
    return resCallbacks;
  });
  _classPrivateFieldSet(_registryConf, this, registryConf);
  _classPrivateFieldSet(_bundleLoader, this, bundleLoader);
  _classPrivateFieldSet(_getAppSdkAdapter, this, getAppSdkAdapter);
  _classPrivateFieldSet(_debug, this, debug('ILC:ParcelApi'));
});
export { ParcelApi as default };